<ul class="tabs py-3 px-1 flex flex-row gap-3">
  <li class="tab"><button [class.active]="activeTab === 'vagas'" (click)="changeTab('vagas')">Vagas</button></li>
  <li class="tab"><button [class.active]="activeTab === 'candidaturas'" (click)="changeTab('candidaturas')">Minhas Candidaturas</button></li>
</ul>
<router-outlet></router-outlet>
